import React, { useEffect, useState } from "react";
import { Smartphone, Download, Share2, Plus, CheckCircle2 } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function GetApp() {
  const [deferred, setDeferred] = useState(() => window.__omiInstallPrompt || null);
  const [installed, setInstalled] = useState(false);

  useEffect(() => {
    const h = (e) => { e.preventDefault(); window.__omiInstallPrompt = e; setDeferred(e); };
    const ready = () => setDeferred(window.__omiInstallPrompt);
    window.addEventListener("beforeinstallprompt", h);
    window.addEventListener("omi-install-ready", ready);
    window.addEventListener("appinstalled", () => setInstalled(true));
    return () => {
      window.removeEventListener("beforeinstallprompt", h);
      window.removeEventListener("omi-install-ready", ready);
    };
  }, []);

  const install = async () => {
    if (!deferred) return;
    deferred.prompt();
    const { outcome } = await deferred.userChoice;
    if (outcome === "accepted") setInstalled(true);
    setDeferred(null);
    window.__omiInstallPrompt = null;
  };

  return (
    <div className="max-w-2xl mx-auto px-6 py-16" data-testid="get-app-page">
      <div className="text-center">
        <div className="w-16 h-16 rounded-2xl bg-teal-50 text-teal-600 flex items-center justify-center mx-auto mb-5"><Smartphone className="w-8 h-8" /></div>
        <h1 className="font-display text-4xl font-extrabold text-[#0B223D]">Get the Credit Kendra App</h1>
        <p className="text-slate-500 mt-3">Apne mobile par Credit Kendra app install karein — ek tap me home screen par add ho jayega, bilkul native app jaisa. Login ID &amp; password save karne ka option bhi hai.</p>
      </div>

      <div className="mt-8 bg-white border border-slate-200 rounded-3xl shadow-sm p-7 text-center">
        {installed ? (
          <div className="text-teal-600"><CheckCircle2 className="w-12 h-12 mx-auto mb-2" /><p className="font-bold text-lg">App installed! Home screen par dekho.</p></div>
        ) : (
          <div className="space-y-5">
            <Button onClick={install} disabled={!deferred} data-testid="install-app-btn"
              className="bg-[#0B223D] hover:bg-[#06182B] text-white font-bold h-14 px-8 rounded-xl text-lg w-full sm:w-auto disabled:opacity-40">
              <Download className="w-5 h-5 mr-2" /> Install App
            </Button>
            {!deferred && <p className="text-xs text-slate-400 -mt-2">Button active nahi? Neeche manual steps follow karein — 30 second ka kaam hai.</p>}
            <div className="text-left space-y-4 pt-2">
              <p className="font-bold text-[#0B223D]">Manual install:</p>
              <div className="bg-slate-50 rounded-xl p-4">
                <p className="font-semibold text-[#0B223D] flex items-center gap-2"><Smartphone className="w-4 h-4" /> Android (Chrome)</p>
                <p className="text-sm text-slate-600 mt-1">Menu (⋮) → <b>Add to Home screen</b> / <b>Install app</b> → Install.</p>
              </div>
              <div className="bg-slate-50 rounded-xl p-4">
                <p className="font-semibold text-[#0B223D] flex items-center gap-2"><Share2 className="w-4 h-4" /> iPhone (Safari)</p>
                <p className="text-sm text-slate-600 mt-1">Share button → <b>Add to Home Screen</b> <Plus className="w-3 h-3 inline" /> → Add.</p>
              </div>
            </div>
          </div>
        )}
      </div>
      <div className="mt-8 grid sm:grid-cols-3 gap-3" data-testid="role-apps">
        {[
          ["CK Adviser", "Adviser dashboard app — referral links, leads & wallet", "/login?role=adviser", "bg-[#0B223D]", "A"],
          ["CK Team", "Campaign Manager / Employee console app", "/login", "bg-indigo-600", "T"],
          ["CK Admin", "Super Admin console app — full control", "/login?role=super", "bg-teal-600", "Ad"],
        ].map(([name, desc, url, color, letter]) => (
          <a key={name} href={url} data-testid={`role-app-${name.replace(/\s+/g, "-").toLowerCase()}`}
            className="bg-white border border-slate-200 rounded-2xl p-4 hover:border-teal-300 hover:shadow-sm transition-all block">
            <span className={`w-9 h-9 rounded-xl ${color} text-white font-display font-extrabold text-xs flex items-center justify-center`}>{letter}</span>
            <p className="font-bold text-sm text-[#0B223D] mt-2">{name}</p>
            <p className="text-xs text-slate-400 mt-1">{desc}</p>
            <p className="text-[11px] text-teal-600 font-semibold mt-2">Is link par jaakar install karein →</p>
          </a>
        ))}
      </div>
      <p className="text-xs text-slate-400 text-center mt-5">Installable PWA app — direct install, Play Store ki zaroorat nahi. Offline bhi khulta hai aur login saved rehta hai.</p>
    </div>
  );
}
